import { takeLatest } from 'redux-saga/effects';
import {
  getTrainingModuleRequestListSuccess, getTrainingModuleRequestListFail,
  getTrainingModuleRequestDetailsSuccess, getTrainingModuleRequestDetailsFail
} from './trainingModuleRequestState';
import createCrudService from '../../services/crudservice';
import { 
	doCrudCall, SAVING_MSG, UPDATING_MSG, DELETING_MSG, LOADING_MSG,
	createRecordSuccess, updateRecordSuccess, deleteRecordSuccess
} from '../../utils/crudSagaHelper';

const crudService = createCrudService('api/v1/training/training-module-requests');
const redirectData = {route:'/console/training-module-requests', mode: 'list', recordId:0 };
const modelName = 'Training Module Requests';
const modelId = 'tmr_id';

function* getTrainingModuleRequestList(data) {
	yield doCrudCall(
		() => crudService.getList(data.payload), 
		getTrainingModuleRequestListSuccess, 
		getTrainingModuleRequestListFail, null, null, LOADING_MSG);
}

function* getTrainingModuleRequestDetails(data) {
	yield doCrudCall(
		() => crudService.getDetails(data.payload), 
		getTrainingModuleRequestDetailsSuccess, 
		getTrainingModuleRequestDetailsFail, null, null, LOADING_MSG);		
}

function* doTrainingModuleRequestCreate(data){
	yield doCrudCall(
		() => crudService.doCreate(data.payload), 
		getTrainingModuleRequestDetailsSuccess, 
		getTrainingModuleRequestDetailsFail,
		createRecordSuccess(modelName),
		{...redirectData, mode: 'reload'},
		SAVING_MSG);
}

function* doTrainingModuleRequestUpdate(data){
	console.log(modelId);
	yield doCrudCall(
		() => crudService.doUpdate(data.payload[modelId], data.payload), 
		getTrainingModuleRequestDetailsSuccess, 
		getTrainingModuleRequestDetailsFail,
		updateRecordSuccess(modelName),
		{...redirectData, mode: "reload" },
		UPDATING_MSG);	
}

function* doTrainingModuleRequestDelete(data){
	yield doCrudCall(
		() => crudService.doDelete(data.payload.recordId), 
		getTrainingModuleRequestDetailsSuccess, 
		getTrainingModuleRequestDetailsFail,
		deleteRecordSuccess(modelName),
		{...redirectData, mode: data.payload.mode},
		DELETING_MSG);	
}

function* trainingModuleRequestSaga() {
  yield takeLatest('trainingModuleRequest/getTrainingModuleRequestList', getTrainingModuleRequestList);
  yield takeLatest('trainingModuleRequest/getTrainingModuleRequestDetails', getTrainingModuleRequestDetails);
  yield takeLatest('trainingModuleRequest/doTrainingModuleRequestCreate', doTrainingModuleRequestCreate);
  yield takeLatest('trainingModuleRequest/doTrainingModuleRequestUpdate', doTrainingModuleRequestUpdate);
  yield takeLatest('trainingModuleRequest/doTrainingModuleRequestDelete', doTrainingModuleRequestDelete);  
}

export default trainingModuleRequestSaga;
